module.exports = __webpack_public_path__ + "static/sprockets-897f3522260e371f2c7aa6b84aeb8ec9.jpg";